<template>
  <nav>
    <!-- h2>Dashboard</h2>
    <menu>
      <NavLink to="/" label="Home" icon="home" tooltip="Home" />
    </menu -->

    <h2>Finance</h2>
    <menu>
      <NavLink to="/finance" label="Invoicing input" icon="euro" tooltip="Finance Invoicing input" />
    </menu>

  </nav>
</template>
<script lang="ts">
import NavLink from '@/components/structure/NavLink.vue';

export default {
  components: {
    NavLink,
  },
};
</script>
